import React from "react";
import {Redirect} from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ReactImageAppear from "react-image-appear";
import Container from "react-bootstrap/Container";
import Fade from "react-reveal/Fade";
import QtaSelector from "../parts/QtaSelector";
import ErrorMessage from "../parts/ErrorMessage";

class PiattiList extends React.Component{
    constructor(props) {
        super(props);
    }

    // Sincronizza la categoria nello stato e ciò che è riportato sul link
    componentDidMount() {
        if((this.props.currentCategoria && this.props.currentCategoria.id !== this.props.currentCategoriaInLink)){
            this.props.setCurrentCategoria(this.props.currentCategoriaInLink);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if((this.props.currentCategoria && this.props.currentCategoria.id !== this.props.currentCategoriaInLink)){
            this.props.setCurrentCategoria(this.props.currentCategoriaInLink);
        }
    }

    render() {
        return <Container fluid>
            <div className={"under-header"}>
                <ErrorMessage />
                <Row id={"menuContent"}>
                    {// mostra un messaggio se non ci sono piatti nella cetegoria
                        this.props.piattiFiltrati.length === 0 && <div className={"non-available"}>
                            <i className="fas fa-exclamation-triangle"></i> Non sono presenti piatti in questa categoria
                        </div>
                    }

                    {
                        this.props.piattiFiltrati.map((piatto) =>
                            <Piatto piatto={piatto}
                                    key={piatto.id}
                                    addToList={this.props.addToList}
                                    currentList={this.props.currentList} />
                        )
                    }
                </Row>
            </div>
        </Container>;
    }
}

function Piatto(props){
    return <Col lg={3} md={4}>
            <div className={"piatto"}>
                <ImmaginePiatto piatto={props.piatto}/>
                <InfoPiatto piatto={props.piatto}
                            currentList={props.currentList}
                            addToList={props.addToList}/>
            </div>
    </Col>;
}

function ImmaginePiatto(props){
    if(!props.piatto.immagine){
        return "";
    }
    return <div className={"piatto-img"}>
        <ReactImageAppear alt={props.piatto.nome}
                          src={props.piatto.immagine}
                          className={"img-fluid"}
                          showLoader={false}
        />
    </div>
}

function InfoPiatto(props){
    return <div className={"piatto-info"}>
        <div className="piatto-title">{`${props.piatto.numero}. ${props.piatto.nome}`}</div>
        <div className="piatto-ingredienti">{props.piatto.ingredienti}</div>
        <div className="piatto-prezzo">€ {props.piatto.prezzo}</div>
        <PiattoButtons piatto={props.piatto}
                       currentList={props.currentList}
                       addToList={props.addToList}/>
    </div>
}

class PiattoButtons extends React.Component{
    constructor(props) {
        super(props);
        this.state = {qta: 1}
    }

    modificaQta = (val) =>{
        if(val < 0){
            if(this.state.qta > 1)
                this.setState({qta: this.state.qta-1});
        }else{
            this.setState({qta: this.state.qta+1});
        }
    }

    aggiungiAllaLista = ()=>{
        this.props.addToList(this.props.piatto, this.props.currentList, this.state.qta);
    }

    render() {
        return <>
            <Row>
                <Col xs={6}>
                    <QtaSelector modificaQta={this.modificaQta}
                                 qta={this.state.qta}/>
                </Col>
                <Col xs={6}>
                    <div className="btn btn-aggiungi button-aggiungi" onClick={this.aggiungiAllaLista}>AGGIUNGI</div>
                </Col>
            </Row>
        </>
    }
}


export default PiattiList;
